import {defineAsyncComponent} from 'vue';

const DemoSignReport = defineAsyncComponent(() =>
  import('@/views/digitalSign/DemoSignReport.vue'),
);

export function registerDigitalSign(app) {
  app.component('DemoSignReport', DemoSignReport);
}
